import { createSlice } from "@reduxjs/toolkit";
import userApi from "../../service/userService";

const currentProfileSlice = createSlice({
    name: 'currentProfile',
    initialState:{
        user:  userApi.getUserLocal()
    },
    reducers:{
        updateCurrentProfile(state, action) {
            console.log('redux updateCurrentProfile ' + action.payload)
            state.user = (action.payload);
          },
    },
    extraReducers:{}
})
export const { updateCurrentProfile } = currentProfileSlice.actions 

export default currentProfileSlice.reducer;